export const reportsPath = {
  /* inject path */
  YOUTUBE_POSTS_TEMPLATES: '/reports/youtube-posts-templates',
  LINKEDIN_POSTS_TEMPLATES: '/reports/linkedin-posts-templates',
  TIK_TOK_POSTS_TEMPLATES: '/reports/tiktok-posts-templates',
  INSTAGRAM_POSTS_TEMPLATES: '/reports/instagram-posts-templates',
  TWEETS_TEMPLATES: '/reports/tweets-templates',
  NEWS_TEMPLATES: '//news-templates',
  ENTITIES_TEMPLATES: '/reports/entities-templates',
  INFLUENCERS_TEMPLATES: '/reports/influencers-templates',
  VIDEOS_TEMPLATES: '/reports/videos-templates',
  FAST_REPORT: '/reports/fast-report',
  REPORT_STORE_VERSION_URL: '/reports/:moduleName/charts/download/:id',
  REPORT_STORE_VERSION: '/reports/:moduleName/charts/download/',
  REPORT_DETAILS_URI: '/reports/report-details',
  REPORT_DETAILS: '/reports/report-details/:module/:type?/:id/:name',
  TEMPLATE_DETAILS: '/reports/template-details/:module/:id',
  TEMPLATE_DETAILS_URI: '/reports/template-details',
  ADD_NEW_REPORT_URL: '/reports/add-new-report',
  ADD_NEW_REPORT: '/reports/add-new-report/:module/:type?',
  EDIT_REPORT_URI: '/reports/edit_report',
  EDIT_REPORT: '/reports/edit_report/:module/:type?/:id',

  ADD_TEMPLATE: '/reports/add-template/:modulename/:sub_module_name?',
  ADD_TEMPLATE_URI: '/reports/add-template',
  EDIT_TEMPLATE: '/reports/edit-template/:modulename/:sub_module_name?/:id',
  EDIT_TEMPLATE_URI: '/reports/edit-template',
  CLONE_TEMPLATE: '/reports/clone-template/:modulename/:sub_module_name?/:id',
  CLONE_TEMPLATE_URI: '/reports/clone-template',

  HASHTAGS_TEMPLATES: '/reports/hashtags-templates',
  NEWS_TEMPLATES: '/reports/news-templates',
};
